import { render, staticRenderFns } from "./appDown.vue?vue&type=template&id=25c3b242&scoped=true&"
import script from "./appDown.vue?vue&type=script&lang=js&"
export * from "./appDown.vue?vue&type=script&lang=js&"
import style0 from "./appDown.vue?vue&type=style&index=0&id=25c3b242&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c3b242",
  null
  
)

export default component.exports